import './styles.scss';
import type { FunctionComponent, PropsWithChildren } from 'react';

type ModalProps = {
  title: string;
  subtitle: { firstLine: string; secondLine: string };
  onClose: () => void;
};

const Modal: FunctionComponent<PropsWithChildren<ModalProps>> = ({
  title = '',
  subtitle,
  onClose,
  children,
}) => (
  <div className="modal__container">
    <div className="modal">
      <div className="modal__container__close">
        <button type="button" onClick={onClose} className="modal__container__close__button">
          <i className="far fa-times" />
        </button>
      </div>
      {title && <div className="modal__title">{title}</div>}
      {subtitle && (
        <>
          <div className="modal__subtitle">
            {subtitle.firstLine}
            <span>{subtitle.secondLine}</span>
          </div>
        </>
      )}
      <div className="modal__content">{children}</div>
    </div>
  </div>
);

export default Modal;
